import React, { ReactElement } from "react";
import { GridRow, GridColumn } from "@screencloud/screencloud-ui-components";

import "./TokenError.scss";

const TokenError = (): ReactElement<void> => {
  return (
    <GridRow>
      <GridColumn width={16}>
        <div className="initial-setup">
          <div className="initial-setup_content">
            <h3>A studio authentication token was not loaded successfully.</h3>
            <p>Please try again later.</p>
          </div>
        </div>
      </GridColumn>
    </GridRow>
  );
};

export default TokenError;
